import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import VueMask from "v-mask";
import * as VueGoogleMaps from "vue2-google-maps";
import VueYoutube from "vue-youtube";
import VueFormulate from "@braid/vue-formulate";
import vco from "v-click-outside";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import api from "./api";
import VueSessionStorage from "vue-sessionstorage";
import router from "./router";
import store from "@/state/store";
import i18n from "./i18n";
import "@/assets/scss/app.scss";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import IdleVue from "idle-vue";
import VueDateFns from "vue-date-fns";
import { dynamicComponentsMixin } from "./mixins/dynamicComponentsMixin";
import PortalVue from "portal-vue";

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(VueSessionStorage);
Vue.use(VueYoutube);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueFormulate);
Vue.use(vco);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueDateFns);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(PortalVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places",
  },
  installComponents: true,
});
Vue.component("apexchart", VueApexCharts);

Vue.mixin(dynamicComponentsMixin);

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1000 * 60 * 10,
});

// Clear IP cache on app initialization (full page refresh)
localStorage.removeItem("client_ip");
console.log("IP cache cleared on app initialization");

let app = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  onIdle() {
    if (window.location.pathname != "/login") {
      Swal.fire({
        timer: 10000,
        showCancelButton: true,
        confirmButtonText: "Stay Connected",
        cancelButtonText: "Logout",
        confirmBtnBsStyle: "success",
        cancelBtnBsStyle: "danger",
        title: "Session Expired",
        html: "You have left this browser idle for 10 minutes. Redirecting in 10 seconds",
      }).then((result) => {
        if (result.isDismissed) {
          this.$router.push({ name: "logout" });
        }
      });
    }
  },
  render: (h) => h(App),
}).$mount("#app");

function sleep(seconds) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}

Vue.mixin({
  data() {
    return {};
  },
  methods: {
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Creating Practices",
        html: "Do not interrupt this process.",
        timer: 350000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          // timerInterval = setInterval(() => {
          //   Swal.getContent().querySelector(
          //     "b"
          //   ).textContent = Swal.getTimerLeft();
          // }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    async createPractice(userId, val) {
      if (val) {
        var data = {
          uuid: uuidv4(),
          code: "N/A",
          type: "N/A",
          active: true,
          name: val.name,
          phone: "",
          address: {
            address: "",
          },
          deleted: false,
          createdDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          isChild: true,
          locationId: "",
          pcnId: val.pcn,
          additionalProp1: {
            dynamo: val.dynamo,
            url: val.url,
            postcode: val.postcode,
            pcncode: val.pcncode,
            pcnname: val.pcnname,
            ccgcode: val.ccgcode,
            ccgname: val.ccgname,
            stpcode: val.stpcode,
            stpname: val.stpname,
            regioncode: val.regioncode,
            regionname: val.regionname,
          },
        };
        return await new Promise((resolve) => {
          api.post("/api/practices", data).then(
            async (response) => {
              this.$bvModal.hide("modal" + userId);
              await this.createPracticeData(response.data.id, val.url);
              resolve(response);
            },
            (error) => {
              console.log(error);
            }
          );
        });
      }
    },
    async createPracticeData(practiceId, url) {
      var data = {
        uuid: uuidv4(),
        openingHours: {},
        interimHours: {},
        holidayHours: {},
        holidays: [],
        deleted: false,
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        practiceId: practiceId,
        fromParent: true,
        additionalProp1: {},
      };
      return await new Promise((resolve) => {
        api.post("/api/practices/" + practiceId + "/practice-data", data).then(
          async (response) => {
            // console.log(response);
            await this.createCms(response.data.id, url);
            resolve(response);
          },
          (error) => {
            console.log(error);
          }
        );
      });
    },
    async createCms(practiceDataId, url) {
      var data = {
        uuid: uuidv4(),
        creationDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        practiceDataId: practiceDataId,
        additionalProp1: {},
      };
      return await new Promise((resolve) => {
        api.post("/api/practice-data/" + practiceDataId + "/cms", data).then(
          async (response) => {
            // console.log(response);
            await this.createCategory(response.data.id, url);
            resolve(response);
          },
          (error) => {
            console.log(error);
          }
        );
      });
    },
    async createPage(catId, cmsId, page, count) {
      try {
        await api.post(`/api/categories/${catId}/pages`, {
          uuid: uuidv4(),
          url: "",
          active: page.active,
          title: page.title,
          label: page.label,
          color: page.color,
          icon: page.icon,
          link_url: page.link_url,
          picture: "",
          excerpt: "NA",
          description: "",
          deleted: false,
          creationDate: "2022-09-20T15:21:17.707Z",
          lastModifiedDate: "2022-09-20T15:21:17.707Z",
          categoryId: catId,
          cmsId: cmsId,
          additionalProp1: {
            position: count,
            color: page.color,
            icon: page.icon,
            link_url: page.link_url,
          },
        });
        console.log("posted", page.title);
      } catch (e) {
        console.log(e);
      }
    },
    async postDataSickFitNotes(catId, cmsId, data) {
      const page = {
        uuid: uuidv4(),
        url: "",
        active: true,
        title: data.title,
        picture: "",
        excerpt: "NA",
        description: "",
        deleted: false,
        creationDate: "2023-03-08T22:43:57.104Z",
        lastModifiedDate: "2023-03-08T22:43:57.104Z",
        categoryId: catId,
        cmsId: cmsId,
        additionalProp1: {
          position: data.additionalProp1.position,
          answer: data.answer,
        },
        answer: data.answer,
      };

      try {
        const pstd = await api.post(`/api/categories/${catId}/pages`, page);
        console.log("POSTED", pstd.data.id);
      } catch (e) {
        console.log("ERR", e);
      }
    },
    async postDataOnlineServices(catId, cmsId, data) {
      const page = {
        uuid: uuidv4(),
        url: "",
        active: data.active,
        title: data.title,
        picture: "",
        excerpt: "NA",
        description: "",
        deleted: false,
        creationDate: "2023-03-08T22:43:57.104Z",
        lastModifiedDate: "2023-03-08T22:43:57.104Z",
        categoryId: catId,
        cmsId: cmsId,
        additionalProp1: {
          position: data.position,
        },
      };

      try {
        const pstd = await api.post(`/api/categories/${catId}/pages`, page);
        console.log("POSTED", pstd.data.id);
      } catch (e) {
        console.log("ERR", e);
      }
    },
    createCategorySubFn(cmsId, catData) {
      console.log(catData);

      const categoryData = JSON.parse(JSON.stringify(catData));
      return new Promise((resolve) => {
        api
          .post("/api/cms/" + cmsId + "/categories", categoryData)
          .then((response) => {
            // console.log(response)

            return resolve(response);
          });
        // .then(async () => {
        //   // console.log(response);
        //   Swal.fire("Practice Created!", "Practice, Practice Data, CMS and Default Categories Created Successfully!", "success");
        //   // resolve(response)
        // }, (error) => {
        //   console.log(error);
        // });
      });
    },
    async createCategory(cmsId, url) {
      const sender = `no-reply@${url}`;
      const categoryItems = [
        {
          label: "Info Pages",
          icon: "pages.svg",
          link: "/pages/pages",
        },
        {
          label: "Practice Team",
          icon: "practice_team.svg",
          link: "/pages/practice-team",
          groups: [],
        },
        {
          label: "Opening Hours",
          icon: "opening_hours.svg",
          link: "/pages/opening-hours",
        },
        {
          label: "News",
          icon: "news.svg",
          link: "/pages/news",
        },
        {
          label: "Alerts",
          icon: "alerts.svg",
          link: "/pages/alerts",
        },
        {
          label: "Documents",
          icon: "documents.svg",
          link: "/pages/documents",
        },
        {
          label: "Locations",
          icon: "location.svg",
          link: "/pages/locations",
        },
        {
          label: "Online Services",
          icon: "online_services.svg",
          link: "/pages/online-services",
        },
        {
          label: "Job Vacancies",
          icon: "job-vacancies.svg",
          link: "/pages/job-vacancies",
        },
        {
          label: "Footer",
          icon: "footer.svg",
          link: "/pages/footer",
        },
        {
          label: "Quick Links",
          icon: "quicklinks.svg",
          link: "/pages/quicklinks",
        },
        {
          label: "Sick/Fit Notes",
          icon: "sicknotes.svg",
          link: "/pages/sicknotes",
        },
        {
          label: "Clinics & Services",
          icon: "clinics_and_services.svg",
          link: "/pages/clinics_and_services",
        },
        {
          label: "Carer Information",
          icon: "carer_info.svg",
          link: "/pages/carer_info",
        },
        {
          label: "Patient Group",
          icon: "patientgroup.svg",
          link: "/pages/patientgroup",
        },
        {
          label: "Social Media",
          icon: "social_media.svg",
          link: "/pages/social_media",
        },
        {
          label: "Social Media",
          icon: "social_media.svg",
          link: "/pages/social_media",
        },
        {
          label: "Mail Settings",
          icon: "mail_settings.svg",
          link: "/pages/mail_settings",
        },
      ];
      this.timer();

      for (const item of categoryItems) {
        console.log(item);
        // const catData = {
        //   uuid: uuidv4(),
        //   name: item.label,
        //   creationDate: new Date().toISOString(),
        //   updatedDate: new Date().toISOString(),
        //   cmsId: cmsId,
        //   fields: {},
        //   additionalProp1: {
        //     icon: item.icon,
        //     link: item.link
        //   }
        // };
        let category_data = {
          uuid: uuidv4(),
          name: item.label,
          creationDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          cmsId: cmsId,
          fields: {},
          additionalProp1: {
            icon: item.icon,
            link: item.link,
          },
        };
        if (item.label == "Practice Team")
          Object.assign(category_data.additionalProp1, {
            groups: [
              {
                id: uuidv4(),
                subgroups: [],
                active: true,
                title: "Doctors",
                name: "Doctors",
              },
            ],
          });
        if (item.label == "Locations")
          Object.assign(category_data.additionalProp1, { text: "" });
        if (item.label == "Patient Group")
          Object.assign(category_data.additionalProp1, {
            ppg_newsletters: false,
            ppg_form_select: "Template A",
            text: "<p>The Patient Participation Group allows patients to feedback constructive comments and suggestions for improvements to services provided by the practice. It is run by volunteers who give up a bit of their time to be the voice of the patients to the surgery and to put on activities such as the newsletter and the health talks.</p><p>If you would like to join our group, please complete the following application form and we will then register you to be included in our group. Your contact details will be kept safe.</p>",
            ppg_minutes_list: [
              {
                title: "Sample",
                id: "e03e8e77-6b66-4ef7-8304-1e53645af757",
              },
            ],
            ppg_documents: false,
            ppg_documents_list: [],
            ppg_newsletters_list: [
              {
                title: "Sample Newsletter",
                id: "ff1b9273-bb3c-48aa-88fa-55adf0cfeb9a",
              },
            ],
            ppg_form: true,
            ppg_minutes: false,
          });
        if (item.label == "Job Vacancies")
          Object.assign(category_data.additionalProp1, { text: "" });
        if (item.label == "Online Services")
          Object.assign(category_data.additionalProp1, {
            text: "",
            nhs_app: false,
            patient_access: false,
          });
        if (item.label == "Sick/Fit Notes")
          Object.assign(category_data.additionalProp1, {
            info_description:
              '<p>There is a National online system for getting a Fit note for the purpose of self-isolation. You do not need to contact or see the GP for this. Please click <a href="https://111.nhs.uk/isolation-note">here</a>.</p>',
            sick_fit_notes_form: true,
            processing_time: "",
            practice_location_check: false,
            nhs_app_toggle_check: false,
            info_box: true,
            gp_and_nurse_availability_check: false,
            webform_toggle_check: false,
            practice_team_check: false,
            patient_access_toggle_check: false,
            sick_fit_notes_form_type: "Online Form",
            contact_us_check: false,
            description:
              "<p>Fit notes are issued to patients by doctors following an assessment of their fitness for work. A fit note is issued after the first seven days of sickness absence (when patients can self-certify) if the doctor assesses that the patient’s health affects their fitness for work.</p><p>The doctor can decide the patient is 'unfit for work' or 'may be fit for work subject to the following advice...' with accompanying notes on suggested adjustments or adaptations to the job role or workplace.</p>",
            inperson_toggle_check: false,
            system_online_toggle_check: false,
            when_we_are_closed_check: false,
            help_us_help_you: true,
            info_title: "Fit Note for Self-Isolation",
            online_consultation_link: "",
          });
        if (item.label == "Clinics & Services")
          Object.assign(category_data.additionalProp1, {
            text: "",
            expanded: false,
            groups: [],
          });
        if (item.label == "Carer Information")
          Object.assign(category_data.additionalProp1, {
            info_box: false,
            carer_form: true,
            description:
              "<p>It’s important for us to be aware that you are a carer so we can offer you help and support if you need it. Anyone who looks after a friend or family member who cannot manage without them, and is unpaid, can register. This includes carers under the age of 18.</p><p>If you are a carer, please complete the form below.</p>",
            info_title: "",
            info_description: "",
          });
        if (item.label == "Social Media")
          Object.assign(category_data.additionalProp1, {
            facebook_url: "",
            facebook_footer: false,
            facebook_patientnews: false,
            twitter_url: "",
            twitter_footer: false,
            twitter_patientnews: false,
            youtube_url: "",
            youtube_footer: false,
            youtube_patientnews: false,
            instagram_url: "",
            instagram_footer: false,
            instagram_patientnews: false,
          });
        if (item.label == "News")
          Object.assign(category_data.additionalProp1, {
            contact_us_check: false,
            practice_newsletters_list: [],
            twitter: false,
            facebook: false,
            when_we_are_closed_check: false,
            gp_and_nurse_availability_check: false,
            practice_team_check: false,
            practice_newsletters: false,
            know_where_to_go: false,
            practice_location_check: false,
          });
        if (item.label == "Footer")
          Object.assign(category_data.additionalProp1, {
            learning_disability_friendly_status: false,
            dementia_friendly_url: "",
            armed_forces_veteran_status: false,
            armed_forces_veteran_url: "",
            learning_disability_friendly_url: "",
            ccq_id: "",
            dementia_friendly_status: false,
            get_the_nhs_app: true,
            yellow_fever_zone_status: false,
            yellow_fever_zone_url: "",
          });
        if (item.label == "Mail Settings")
          Object.assign(category_data.additionalProp1, {
            sender_email: sender,
            admin_query_form_email: "",
            smoking_and_alcohol_form_email: "",
            update_clinical_record_form_email: "",
            private_letter_form_email: "",
            change_of_personal_details_form_email: "",
            nhs_health_checks_form_email: "",
            social_prescribing_support_form_email: "",
            nominate_your_pharmacy_form_check: false,
            sick_fit_notes_form_email: "",
            decline_medical_review_form_email: "",
            complaints_form_email: "",
            social_prescribing_support_form_check: false,
            travel_questionare_form_check: false,
            carer_info_form_check: false,
            height_and_weight_update_form_check: false,
            mental_health_occupational_therapy_form_email: "",
            feedback_form_email: "",
            midwife_self_referral_form_check: false,
            children_and_teenagers_with_asthma_form_check: false,
            decline_flu_jab_form_check: false,
            national_data_optout_form_email: "",
            prescriptions_form_email: "",
            ppg_form_check: false,
            summary_care_record_form_email: "",
            cancel_appointment_form_check: false,
            contraceptive_bp_monitoring_form_check: false,
            height_and_weight_update_form_email: "",
            ppg_form_email: "",
            communication_consent_form_check: false,
            default_email: "",
            change_of_personal_details_form_check: false,
            children_and_teenagers_with_asthma_form_email: "",
            home_bp_reading_form_email: "",
            private_letter_form_check: false,
            midwife_self_referral_form_email: "",
            home_bp_reading_form_check: false,
            access_to_medical_records_form_email: "",
            medication_review_form_check: false,
            carer_info_form_email: "",
            nominate_your_pharmacy_form_email: "",
            feedback_form_check: false,
            medication_review_form_email: "",
            travel_questionare_form_email: "",
            mental_health_occupational_therapy_form_check: false,
            complaints_form_check: false,
            decline_medical_review_form_check: false,
            update_clinical_record_form_check: false,
            contraceptive_bp_monitoring_form_email: "",
            sick_fit_notes_form_check: false,
            decline_flu_jab_form_email: "",
            asthma_questionare_form_check: false,
            access_to_medical_records_form_check: false,
            asthma_questionare_form_email: "",
            admin_query_form_check: false,
            prescriptions_form_check: false,
            national_data_optout_form_check: false,
            nhsd_weight_management_form_check: false,
            nhsd_weight_management_form_email: "",
            smoking_and_alcohol_form_check: false,
            cancel_appointment_form_email: "",
            join_the_practice_form_check: false,
            summary_care_record_form_check: false,
            communication_consent_form_email: "",
            nhs_health_checks_form_check: false,
            join_the_practice_form_email: "",
          });
        var result = await this.createCategorySubFn(cmsId, category_data);
        await sleep(5);
        console.log(result);

        if (result.data.name == "Quick Links") {
          const pages = [
            {
              title: "Join the Practice",
              label: "Join the Practice",
              active: true,
              link_url: "/joinpractice",
              color: "#005eb8",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/building.svg",
            },
            {
              title: "Book Appointment",
              label: "Book Appointment",
              active: true,
              link_url: "/appointments",
              color: "#c63763",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/appointment.svg",
            },
            {
              title: "Repeat Prescriptions",
              label: "Repeat Prescriptions",
              active: true,
              link_url: "/prescriptions",
              color: "#409954",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/prescription.svg",
            },
            {
              title: "eConsult",
              label: "Online Consultation",
              active: true,
              link_url: "",
              color: "#00a5ef",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/online_consultation.svg",
            },
            {
              title: "Cancel Appointment",
              label: "Cancel Appointment",
              active: true,
              link_url: "/cancelappointment",
              color: "#535862",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/cancel_appointment.svg",
            },
            {
              title: "Sick / Fit Notes",
              label: "Sick / Fit Notes",
              active: true,
              link_url: "/page/sickfitnotes",
              color: "#ffb902",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/notes.svg",
            },
            {
              title: "Test Results",
              label: "Test Results",
              active: true,
              link_url: "/testresult",
              color: "#f35022",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/results.svg",
            },
            {
              title: "Healthier Together",
              label: "Healthier Together",
              active: false,
              link_url: "",
              color: "#005eb8",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/healthier_together.svg",
            },
            {
              title: "Self Referrals",
              label: "Self Referrals",
              active: false,
              link_url: "/page/selfreferrals",
              color: "#670287",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/referals.svg",
            },
            {
              title: "Administrative Query",
              label: "Administrative Query",
              active: false,
              link_url: "/page/administrativequery",
              color: "#715bff",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/ask_a_question.svg",
            },
            {
              title: "GP & Nurse Availability",
              label: "GP & Nurse Availability",
              active: false,
              link_url: "/staffavailability",
              color: "#00a5ef",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/nurse.svg",
            },
            {
              title: "Mental Health",
              label: "Mental Health",
              active: false,
              link_url: "",
              color: "#78be21",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/mental_health.svg",
            },
            {
              title: "Self Care",
              label: "Self Care",
              active: false,
              link_url: "",
              color: "#715bff",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/self_care.svg",
            },
            {
              title: "When Closed",
              label: "When Closed",
              active: false,
              link_url: "/appointments/whenclosed",
              color: "#535862",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/closed.svg",
            },
            {
              title: "Clinics and Services",
              label: "Clinics and Services",
              active: false,
              link_url: "/page/clinics",
              color: "#715bff",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/clinics.svg",
            },
            {
              title: "COVID-19 Boosters",
              label: "COVID-19 Boosters",
              active: false,
              link_url: "",
              color: "#41b056",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/covid.svg",
            },
            {
              title: "Online Services",
              label: "Online Services",
              active: false,
              link_url: "/onlineservices",
              color: "#005eb8",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/online_services.svg",
            },
            {
              title: "Patient News",
              label: "Patient News",
              active: false,
              link_url: "/patientnews",
              color: "#c0007c",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/patient_news.svg",
            },
            {
              title: "Manage Your Condition",
              label: "Manage Your Condition",
              active: false,
              link_url: "",
              color: "#f35022",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/manage_condition.svg",
            },
            {
              title: "Hypertension Plus",
              label: "Hypertension Plus",
              active: false,
              link_url: "/page/hypertensionplusapp",
              color: "#005eb8",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/pills.svg",
            },
            {
              title: "Patient Guides",
              label: "Patient Guides",
              active: false,
              link_url: "/page/patientguides",
              color: "#109f72",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/patientguides.svg",
            },
            {
              title: "Wellbeing Support",
              label: "Wellbeing Support",
              active: false,
              link_url: "/page/communitysupport",
              color: "#42a4bd",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/wellbeing_support.svg",
            },
            {
              title: "Women’s Health Clinic",
              label: "Women’s Health Clinic",
              active: false,
              link_url: undefined,
              color: "#715bff",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/womens_health_clinic.svg",
            },
            {
              title: "Blood Pressure Monitoring",
              label: "Blood Pressure Monitoring",
              active: false,
              link_url: "/page/submithomebpreading",
              color: "#f35022",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/blood_pressure_monitoring.svg",
            },
            {
              title: "Carer Information",
              label: "Carer Information",
              active: false,
              link_url: "/carerinformation",
              color: "#7f4a9d",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/career_info.svg",
            },
            {
              title: "Klinik",
              label: "Online Consultation",
              active: false,
              link_url: "",
              color: "#109f72",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/k_consult.svg",
            },
            {
              title: "accuRx",
              label: "Online Consultation",
              active: false,
              link_url: "",
              color: "#0b8888",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/online_consult.svg",
            },
            {
              title: "Patchs",
              label: "Online Consultation",
              active: false,
              link_url: "",
              color: "#7f4a9d",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/add_consult.svg",
            },
            {
              title: "Rapid Health",
              label: "Online Consultation",
              active: false,
              link_url: "",
              color: "#7f4a9d",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/add_consult.svg",
            },
            {
              title: "Anima Health",
              label: "Online Consultation",
              active: false,
              link_url: "",
              color: "#9e1cd8",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/anima-health-white.png",
            },
            {
              title: "Ask my GP",
              label: "Online Consultation",
              active: false,
              link_url: "",
              color: "#42a4bd",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/oc_mobiles.svg",
            },
            {
              title: "Get U Better",
              label: "Muscle and Joint Problems",
              active: false,
              link_url: "",
              color: "#7fccff",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/getubetter.png",
            },
            {
              title: "Travel Questionnaire",
              label: "Travel Questionnaire",
              active: false,
              link_url: "/travelquestionnaire",
              color: "#00a5ef",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/travel.svg",
            },
            {
              title: "Practice Team",
              label: "Practice Team",
              active: false,
              link_url: "/practiceteam",
              color: "#715bff",
              icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/practice_team.svg",
            },
          ];
          for (let i = 0; i < pages.length; i++) {
            await this.createPage(
              result.data.id,
              result.data.cmsId,
              pages[i],
              i
            );
            await sleep(5);
          }
        }

        if (result.data.name == "Sick/Fit Notes") {
          const pages = [
            {
              id: "6434474fecc688ef33254a9b",
              uuid: "fb049de6-1464-474e-88e3-924b2647a8d8",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Where do I get more information on Sick Notes?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:28:47.767Z",
              lastModifiedDate: "2023-04-10T17:28:47.767Z",
              categoryId: "63f613f6acf76805b35f7cd8",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 0,
              },
              answer:
                '<p><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);">To know more on Sick/Fit notes, visit </span><a href="https://www.gov.uk/taking-sick-leave">https://www.gov.uk/taking-sick-leave.</a></p>',
              timestamp: "2023-04-10T17:28:47.385Z",
            },
            {
              id: "64344764ecc688ef33254a9f",
              uuid: "e7bfeefb-5392-4447-95dd-7925d00e0a31",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Do I need a return to work note?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:29:08.736Z",
              lastModifiedDate: "2023-04-10T17:29:08.736Z",
              categoryId: "63f613f6acf76805b35f7cd8",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 1,
              },
              answer:
                "<p>If you are fit for work, you do not need a fit note.</p><p>Your doctor will only give you a fit note if your health affects your fitness for work.</p>",
              timestamp: "2023-04-10T17:29:08.328Z",
            },
            {
              id: "6434477aecc688ef33254aa7",
              uuid: "6d6b7f0c-6f42-45d2-a8f6-e02868f9dadd",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Can I get a fit note without seeing my GP?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:29:30.794Z",
              lastModifiedDate: "2023-04-10T17:29:30.794Z",
              categoryId: "63f613f6acf76805b35f7cd8",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 2,
              },
              answer:
                '<p><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);">A fit note must be signed by a doctor, but you do not always need to see a GP in person to get one. Please see </span><a href="https://www.nhs.uk/common-health-questions/caring-carers-and-long-term-conditions/can-i-get-a-fit-note-without-seeing-my-gp/">NHS website</a><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);"> for details.</span></p>',
              timestamp: "2023-04-10T17:29:30.392Z",
            },
            {
              id: "64344795ecc688ef33254ab0",
              uuid: "04d95939-7e5c-4c05-8680-98df28e41800",
              url: "frimley.patientlink.digital",
              active: true,
              title:
                "Can I go back to work before the end date on my fit note?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:29:58.079Z",
              lastModifiedDate: "2023-04-10T17:29:58.079Z",
              categoryId: "63f613f6acf76805b35f7cd8",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 3,
              },
              answer:
                '<p><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);">Please check the </span><a href="https://www.nhs.uk/common-health-questions/caring-carers-and-long-term-conditions/can-i-go-back-to-work-before-the-end-date-on-my-fit-note/">NHS website</a><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);"> for details.</span></p>',
              timestamp: "2023-04-10T17:29:57.675Z",
            },
            {
              id: "643447adecc688ef33254abb",
              uuid: "813c90c9-b59f-42dd-a659-b46aa03457df",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Where do I learn more on Statutory Pay?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:30:22.312Z",
              lastModifiedDate: "2023-04-10T17:30:22.312Z",
              categoryId: "63f613f6acf76805b35f7cd8",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 4,
              },
              answer:
                '<p><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);">Please find more details on </span><a href="https://www.gov.uk/guidance/statutory-sick-pay-how-different-employment-types-affect-what-you-pay">Statutory Sick Pay: how different employment types affect what you pay.</a></p>',
              timestamp: "2023-04-10T17:30:21.904Z",
            },
            {
              id: "643447d5ecc688ef33254ac9",
              uuid: "70c5b7c3-a092-4e72-b33a-1c5b43a260ca",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Useful Links",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:31:02.099Z",
              lastModifiedDate: "2023-04-10T17:31:02.099Z",
              categoryId: "63f613f6acf76805b35f7cd8",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 5,
              },
              answer:
                '<ul><li><a href="https://www.gov.uk/guidance/statutory-sick-pay-employee-fitness-to-work">Statutory Sick Pay: employee fitness to work</a></li><li><a href="https://www.gov.uk/government/publications/statutory-sick-pay-employee-not-entitled-form-for-employers">SSP1 form: Statutory Sick Pay and an employee\'s claim for benefit</a></li><li><a href="https://www.gov.uk/government/publications/the-fit-note-a-guide-for-patients-and-employees">Fit note: guidance for patients and employees</a></li><li><a href="https://www.gov.uk/government/collections/fit-note">Fit note</a></li></ul>',
              timestamp: "2023-04-10T17:31:01.696Z",
            },
          ];
          for (let i = 0; i < pages.length; i++) {
            await this.postDataSickFitNotes(
              result.data.id,
              result.data.cmsId,
              pages[i]
            );
            await sleep(5);
          }
        }

        if (result.data.name == "Carer Information") {
          const pages = [
            {
              id: "643448b9ecc688ef33254ade",
              uuid: "fca34f9e-e07a-4a7e-b213-9322f630c56c",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Am I eligible as a carer?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:34:50.159Z",
              lastModifiedDate: "2023-04-10T17:34:50.159Z",
              categoryId: "641d8c6fbec6c441865293cb",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 0,
              },
              answer:
                "<p>A carer looks after a family member, friend, partner or neighbour who needs support due to illness, disability or old age. The help carers give is unpaid, though you may still receive Carer’s Allowance or other benefits. You do not have to care full time to receive Carer’s Allowance or live with the person you care for to be a carer.</p>",
              timestamp: "2023-04-10T17:34:49.764Z",
            },
            {
              id: "643448e6ecc688ef33254ae3",
              uuid: "f549c996-9035-4a2f-a260-3134c3986ba0",
              url: "frimley.patientlink.digital",
              active: true,
              title:
                "I don’t live in the same borough/county as the person I care for – where do I go for help?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:35:34.597Z",
              lastModifiedDate: "2023-04-10T17:35:34.597Z",
              categoryId: "641d8c6fbec6c441865293cb",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 1,
              },
              answer:
                "<p>It is the duty of the local authority (council) where the person you care for lives to assess their care and support needs and your needs as a carer. For example, if the person you care for lives in Sutton, the London Borough of Sutton would be responsible for assessing their support needs and offering you a Carer’s Assessment.</p>",
              timestamp: "2023-04-10T17:35:34.191Z",
            },
            {
              id: "643448ffecc688ef33254aea",
              uuid: "154e0a7f-7550-46a8-8108-9e9cf3b3248b",
              url: "frimley.patientlink.digital",
              active: true,
              title: "What is Carer's Allowance and how do I claim it?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:35:59.874Z",
              lastModifiedDate: "2023-04-10T17:35:59.875Z",
              categoryId: "641d8c6fbec6c441865293cb",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 2,
              },
              answer:
                '<p>Please <a href="https://www.nhs.uk/conditions/social-care-and-support-guide/support-and-benefits-for-carers/benefits-for-carers/">click here</a> for the latest carer’s allowance information.</p>',
              timestamp: "2023-04-10T17:35:59.468Z",
            },
            {
              id: "64344914ecc688ef33254af4",
              uuid: "b12ac83b-9a00-4d3e-a22c-60a3dff9ebcb",
              url: "frimley.patientlink.digital",
              active: true,
              title: "Where could I receive more details on Carer Support?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:36:20.969Z",
              lastModifiedDate: "2023-04-10T17:36:20.969Z",
              categoryId: "641d8c6fbec6c441865293cb",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 3,
              },
              answer:
                '<p>There is a wealth of information on the NHS website about carers and caring. Below are some links into the site that we hope you will find useful.</p><ul><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/introduction-to-care-and-support/">A guide to care and support</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/practical-tips-if-you-care-for-someone/">Caring for someone</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/care-after-a-hospital-stay/">Care after hospital</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/support-and-benefits-for-carers/carer-breaks-and-respite-care/">Taking a break</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/support-and-benefits-for-carers/">Support and benefits for carers</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/money-work-and-benefits/work-and-disability/">Work and Disability</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/support-and-benefits-for-carers/">Being a Young carer</a></li></ul><h4>Finance and Law</h4><p>Help claiming benefits, looking after your bank balance and understanding the legal issues of caring.</p><ul><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/support-and-benefits-for-carers/benefits-for-carers/">Benefits for carers</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/money-work-and-benefits/benefits-for-under-65s/">Benefits for the under-65s</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/money-work-and-benefits/benefits-for-over-65s/">Benefits for the over-65s</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/support-and-benefits-for-carers/carer-assessments/">Carer\'s Assessment</a></li><li><a href="https://www.nhs.uk/conditions/social-care-and-support-guide/money-work-and-benefits/">Other benefits</a></li></ul>',
              timestamp: "2023-04-10T17:36:20.565Z",
            },
          ];
          for (let i = 0; i < pages.length; i++) {
            await this.postDataSickFitNotes(
              result.data.id,
              result.data.cmsId,
              pages[i]
            );
            await sleep(5);
          }
        }

        if (result.data.name == "Patient Group") {
          const pages = [
            {
              id: "6432df7decc688ef33254a53",
              uuid: "b6e34edf-486b-46aa-867d-31ddcd757220",
              url: "frimley.patientlink.digital",
              active: true,
              title: "What is a Patient Participation Group?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-09T15:53:33.986Z",
              lastModifiedDate: "2023-04-09T15:53:33.986Z",
              categoryId: "633b628eb1920c336b15e6aa",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 0,
              },
              answer:
                '<p><span style="color:rgb(0,0,0);background-color:rgb(255,255,255);">The Patient Participation Group allows patients to feedback constructive comments and suggestions for improvements to services provided by the practice. It is run by volunteers who give up a bit of their time to be the voice of the patients to the surgery and to put on activities such as the newsletter and the health talks.</span></p>',
              timestamp: "2023-04-09T15:53:33.780Z",
            },
            {
              id: "6434452cecc688ef33254a73",
              uuid: "ba81ccb9-0bb6-4a8d-aef9-c1ec44dbefcf",
              url: "frimley.patientlink.digital",
              active: true,
              title: "What is the purpose of a PPG?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:19:40.950Z",
              lastModifiedDate: "2023-04-10T17:19:40.950Z",
              categoryId: "633b628eb1920c336b15e6aa",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 2,
              },
              answer:
                "<ul><li>Patients will have a better understanding and knowledge of the practice and its staff.</li><li>This allows latest information to be given to patients regarding the practice and will inform what decisions can be influenced and what cannot.</li><li>It will allow to present the patient’s perspective to the practice staff and help them gain an understanding.</li><li>Patients will benefit from improved communications between patients and staff.</li></ul>",
              timestamp: "2023-04-10T17:19:40.536Z",
            },
            {
              id: "64344554ecc688ef33254a7d",
              uuid: "390e73d3-2926-46af-a5ee-eb9d697fb224",
              url: "frimley.patientlink.digital",
              active: true,
              title: "What are the benefits for the patient?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:20:21.211Z",
              lastModifiedDate: "2023-04-10T17:20:21.211Z",
              categoryId: "633b628eb1920c336b15e6aa",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 3,
              },
              answer:
                "<ul><li>.Patients will have a better understanding and knowledge of the practice and its staff.</li><li>Patients are kept up to date with what is happening in their practice.</li><li>Practice staff will learn more about what patients think and feel and gain greater understanding of their needs.</li><li>Patients will benefit from improved communications between patients and staff</li></ul>",
              timestamp: "2023-04-10T17:20:20.798Z",
            },
            {
              id: "643445a2ecc688ef33254a89",
              uuid: "e308c460-bf27-47b8-8d05-89a3faf7f99a",
              url: "frimley.patientlink.digital",
              active: true,
              title: "What are the benefits for the practice?",
              picture: "",
              excerpt: "NA",
              description: "",
              deleted: false,
              creationDate: "2023-04-10T17:21:38.872Z",
              lastModifiedDate: "2023-04-10T17:21:38.872Z",
              categoryId: "633b628eb1920c336b15e6aa",
              cmsId: "61cc9146ae4142601f6fe35b",
              additionalProp1: {
                dynamoId: "frimley",
                answer: "",
                position: 4,
              },
              answer:
                "<ul><li>GPs and their staff will be able to plan services jointly with patients in order to increase their effectiveness.</li><li>They will be able to get help from patients in meeting targets and objectives.</li><li>They will have a forum to voice concerns, ideas and suggestions to patients.</li><li>They will get closer to the community for whom they care.</li></ul>",
              timestamp: "2023-04-10T17:21:38.462Z",
            },
          ];
          for (let i = 0; i < pages.length; i++) {
            await this.postDataSickFitNotes(
              result.data.id,
              result.data.cmsId,
              pages[i]
            );
            await sleep(5);
          }
        }

        if (result.data.name == "Online Services") {
          const pages = [
            {
              title: "NHS App",
              position: 0,
              active: true,
            },
            {
              title: "Patient Access",
              position: 1,
              active: false,
            },
            {
              title: "SystmOnline",
              position: 2,
              active: false,
            },
          ];
          for (let i = 0; i < pages.length; i++) {
            await this.postDataOnlineServices(
              result.data.id,
              result.data.cmsId,
              pages[i]
            );
            await sleep(5);
          }
        }
      }
      Swal.fire(
        "Practice Created!",
        "Practice, Practice Data, CMS and Default Categories Created Successfully!",
        "success"
      );
    },
    setPracticeVals(user) {
      var url = "/users/" + user.id + "/practicesWithCms";
      if (user.name == "Super Admin") {
        url = "/api/practices";
        let filter = {
          include: [
            {
              relation: "practiceData",
              scope: {
                include: [
                  {
                    relation: "cms",
                  },
                ],
              },
            },
          ],
        };
        filter = encodeURIComponent(JSON.stringify(filter));
        url = `${url}?filter=${filter}`;
      }
      api
        .get(url)
        .then((response) => {
          this.$store.commit("updateAllPractices", response.data);
          // this.practices = response.data;
          if (response.data.length != 0) {
            var firstPrac = response.data[0];
            if (this.$route.params.cmsId) {
              console.log(response.data.length);
              var currPrac = response.data.filter(
                (x) => x.practiceData.cms.id == this.$route.params.cmsId
              )[0];
            }
            if (currPrac) firstPrac = currPrac;
            this.$store.commit("updateCurrentPractice", firstPrac);
            api
              .get("/api/practices/" + firstPrac.id + "/practice-data")
              .then((response) => {
                this.$store.commit("updateCurrentPracticeData", response.data);
                api
                  .get("/api/practice-data/" + response.data.id + "/cms")
                  .then((response2) => {
                    this.$store.commit("updateCurrentCms", response2.data);
                    if (firstPrac.pcnId) {
                      let url = `/api/pcns/${firstPrac.pcnId}`;
                      let filter = {
                        include: [
                          {
                            relation: "practiceData",
                            scope: {
                              include: [
                                {
                                  relation: "cms",
                                },
                              ],
                            },
                          },
                        ],
                      };
                      filter = encodeURIComponent(JSON.stringify(filter));
                      url = `${url}?filter=${filter}`;
                      api
                        .get(url)
                        .then((response3) => {
                          this.$store.commit(
                            "updateCurrentPcn",
                            response3.data
                          );
                          // router.push({name: 'Pages', params: { netId: response3.data.practiceData.cms.id, cmsId: this.currentCms.id }})
                        })
                        .catch((e) => {
                          console.log(e);
                        });
                    } else {
                      this.$store.commit("updateCurrentPcn", null);
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    store.commit("updatePrevSelectedItem", new Object());
    store.commit("updateSelectedItem", new Object());
    next();
  },
  beforeRouteUpdate(to, from, next) {
    store.commit("updatePrevSelectedItem", new Object());
    store.commit("updateSelectedItem", new Object());
    next();
  },
  beforeRouteLeave(to, from, next) {
    store.commit("updatePrevSelectedItem", new Object());
    store.commit("updateSelectedItem", new Object());
    next();
  },
  computed: {
    // prevSelectedItem() {
    //   return this.$store.getters.prevSelectedItem;
    // },
    // selectedItem() {
    //   return this.$store.getters.selectedItem;
    // },
    // createdItem() {
    //   return this.$store.getters.createdItem;
    // },
    // deletedItem() {
    //   return this.$store.getters.deletedItem;
    // },
    currentCategory() {
      return this.$store.getters.currentCategory;
    },
    currentUser() {
      return JSON.parse(sessionStorage.getItem("currentUser"));
    },
    currentPractice() {
      if (
        this.$store.getters.currentPractice &&
        Object.keys(this.$store.getters.currentPractice).length == 0
      ) {
        this.setPracticeVals(this.currentUser);
      }
      return this.$store.getters.currentPractice;
    },
    currentPracticeData() {
      return this.$store.getters.currentPracticeData;
    },
    allPractices() {
      return this.$store.getters.allPractices;
    },
    currentCms() {
      return this.$store.getters.currentCms;
    },
    currentPcn() {
      return this.$store.getters.currentPcn;
    },
  },
});

global.vm = app;
